import * as Sentry from '@sentry/react';
import axios from 'axios';

// Constants
const ROUTE = '/logout'; // POST

// Exports
export const logoutRequest = async () => {
  try {
    await axios.post(ROUTE, undefined, { withCredentials: true });
  } catch (error) {
    if (axios.isAxiosError(error) && error.code === 'ECONNABORTED') {
      // Request aborted, almost certainly because of redirect. Swallow error, but log it as a
      // warning just in case
      Sentry.captureMessage(error.message, Sentry.Severity.Warning);
    } else {
      throw error;
    }
  }
};
